import React from 'react';
export const PlannerCommunity = () => {
  return <section id="community" className="py-24 bg-white relative overflow-hidden" data-id="element-594">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1510137600163-2729bc6959e4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')] opacity-5 bg-fixed" data-id="element-595"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-596">
        <div className="text-center mb-16" data-id="element-597">
          <span className="inline-block px-4 py-1 bg-limestone-200 text-limestone-700 rounded-full text-sm font-medium mb-4" data-id="element-598">
            EXCLUSIVE NETWORK
          </span>
          <h2 className="text-5xl font-serif font-bold mb-6 text-gray-800 tracking-tight" data-id="element-599">
            Join Our Elite Planner Community
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-600">
            Connect with the best wedding planners in the industry and grow
            together.
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-601">
          <div className="space-y-8" data-id="element-602">
            <div className="bg-limestone-50 p-8 rounded-2xl shadow-xl transition-all duration-300 hover:shadow-2xl group" data-id="element-603">
              <div className="flex items-center mb-4" data-id="element-604">
                <div className="p-3 bg-white rounded-full shadow-md mr-4 group-hover:bg-limestone-700 transition-colors duration-300" data-id="element-605">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-limestone-700 group-hover:text-white transition-colors duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-606">
                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-607"></rect>
                    <line x1="16" y1="2" x2="16" y2="6" data-id="element-608"></line>
                    <line x1="8" y1="2" x2="8" y2="6" data-id="element-609"></line>
                    <line x1="3" y1="10" x2="21" y2="10" data-id="element-610"></line>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800" data-id="element-611">
                  Annual EPA Gala
                </h3>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-612">
                Our signature event brings together the most influential wedding
                planners in North America and Latin America for a night of
                luxury, networking, and celebration.
              </p>
              <ul className="space-y-2" data-id="element-613">
                <li className="flex items-start" data-id="element-614">
                  <svg className="h-5 w-5 text-limestone-700 mr-3 mt-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-615">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-616" />
                    <path d="M7.5 12L10.5 15L16.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-617" />
                  </svg>
                  <span className="text-gray-600" data-id="element-618">
                    Hosted at exclusive luxury venues
                  </span>
                </li>
                <li className="flex items-start" data-id="element-619">
                  <svg className="h-5 w-5 text-limestone-700 mr-3 mt-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-620">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-621" />
                    <path d="M7.5 12L10.5 15L16.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-622" />
                  </svg>
                  <span className="text-gray-600" data-id="element-623">
                    Premium entertainment and experiences
                  </span>
                </li>
                <li className="flex items-start" data-id="element-624">
                  <svg className="h-5 w-5 text-limestone-700 mr-3 mt-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-625">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-626" />
                    <path d="M7.5 12L10.5 15L16.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-627" />
                  </svg>
                  <span className="text-gray-600" data-id="element-628">
                    Destination locations change annually
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-limestone-50 p-8 rounded-2xl shadow-xl transition-all duration-300 hover:shadow-2xl group" data-id="element-629">
              <div className="flex items-center mb-4" data-id="element-630">
                <div className="p-3 bg-white rounded-full shadow-md mr-4 group-hover:bg-limestone-700 transition-colors duration-300" data-id="element-631">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-limestone-700 group-hover:text-white transition-colors duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-632">
                    <circle cx="12" cy="12" r="10" data-id="element-633"></circle>
                    <path d="M12 8v4l3 3" data-id="element-634"></path>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800" data-id="element-635">
                  Idea Sessions
                </h3>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-636">
                Quarterly virtual and in-person sessions where members share
                innovative ideas, solve challenges, and discuss industry trends.
              </p>
              <ul className="space-y-2" data-id="element-637">
                <li className="flex items-start" data-id="element-638">
                  <svg className="h-5 w-5 text-limestone-700 mr-3 mt-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-639">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-640" />
                    <path d="M7.5 12L10.5 15L16.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-641" />
                  </svg>
                  <span className="text-gray-600" data-id="element-642">
                    Facilitated by industry experts
                  </span>
                </li>
                <li className="flex items-start" data-id="element-643">
                  <svg className="h-5 w-5 text-limestone-700 mr-3 mt-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-644">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-645" />
                    <path d="M7.5 12L10.5 15L16.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-646" />
                  </svg>
                  <span className="text-gray-600" data-id="element-647">
                    Collaborative problem-solving
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-limestone-50 p-8 rounded-2xl shadow-xl transition-all duration-300 hover:shadow-2xl group" data-id="element-648">
              <div className="flex items-center mb-4" data-id="element-649">
                <div className="p-3 bg-white rounded-full shadow-md mr-4 group-hover:bg-limestone-700 transition-colors duration-300" data-id="element-650">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-limestone-700 group-hover:text-white transition-colors duration-300" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-651">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-652"></path>
                    <circle cx="9" cy="7" r="4" data-id="element-653"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" data-id="element-654"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" data-id="element-655"></path>
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800" data-id="element-656">
                  Mentorship Program
                </h3>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-657">
                Connect with experienced mentors who can help you scale your
                business and overcome challenges.
              </p>
              <ul className="space-y-2" data-id="element-658">
                <li className="flex items-start" data-id="element-659">
                  <svg className="h-5 w-5 text-limestone-700 mr-3 mt-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-660">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-661" />
                    <path d="M7.5 12L10.5 15L16.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-662" />
                  </svg>
                  <span className="text-gray-600" data-id="element-663">
                    One-on-one mentorship sessions
                  </span>
                </li>
                <li className="flex items-start" data-id="element-664">
                  <svg className="h-5 w-5 text-limestone-700 mr-3 mt-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-665">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-666" />
                    <path d="M7.5 12L10.5 15L16.5 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-667" />
                  </svg>
                  <span className="text-gray-600" data-id="element-668">
                    Business growth strategy development
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-669">
          <p className="text-xl italic font-light mb-8 text-limestone-700" data-id="element-670">
            "Better Together"
          </p>
          <a href="#masterclass-curriculum" className="inline-block bg-limestone-700 hover:bg-limestone-800 text-white font-bold py-4 px-10 rounded-lg text-lg transition transform hover:scale-105 shadow-xl relative overflow-hidden group" data-id="element-671">
            <span className="absolute top-0 left-0 w-full h-full bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300" data-id="element-672"></span>
            <span className="relative z-10 flex items-center justify-center" data-id="element-673">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-674">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-675"></path>
                <circle cx="8.5" cy="7" r="4" data-id="element-676"></circle>
                <line x1="20" y1="8" x2="20" y2="14" data-id="element-677"></line>
                <line x1="23" y1="11" x2="17" y2="11" data-id="element-678"></line>
              </svg>
              Join Our Masterclasses
            </span>
          </a>
        </div>
      </div>
    </section>;
};